<template>
  <div>
    <a-modal v-model="visible" :title="getTitle" :width="860" centered :mask-closable="false" :ok-button-props="{ props: { loading: loading } }" @cancel="closed" @ok="onSubmit">
      <a-spin :spinning="spinning">
        <a-form-model ref="form" :model="form" :rules="rules" :form="form">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="评审标题" prop="title">
                <a-input v-model="form.title" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col v-if="!isMrd" :span="8">
              <a-form-model-item label="评审类型" prop="review_scope">
                <a-select v-model="form.review_scope" allow-clear placeholder="评审类型" :disabled="!form.can_modify_scope">
                  <a-select-option v-for="(item, index) in reviewTypes" :key="index" :value="item.value">
                    <a-tag :color="item.color"> {{ item.label }}</a-tag>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="参与人" prop="reviewers">
                <user-select v-model="form.reviewers" mode="multiple" show-search placeholder="参与人" :project-id="projectId" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="计划评审时间" prop="review_time">
                <a-date-picker v-model="form.review_time" :disabled-date="disabledDate" style="width: 100%" :show-time="{ defaultValue: defaultValue, format: 'HH:mm' }" value-format="YYYY-MM-DD HH:mm" placeholder="请选择评审时间" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="描述" prop="description">
                <vditor-editor v-model="form.description" :height="200" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { reviewTypes } from '@/utils/dictionary';
import { reviewAdd, reviewDetail, reviewUpdate } from '@/api/project/review';

import moment from 'moment';
import VditorEditor from '@/components/VditorEditor';
import UserSelect from '@/components/User/UserSelect';

export default {
  components: { VditorEditor, UserSelect },
  props: {
    reviewId: {
      type: [Number, String],
      default: null
    },
    isMrd: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reviewTypes,
      spinning: false,
      loading: false,
      userData: [],
      visible: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      form: {
        title: null,
        description: '',
        review_scope: null,
        reviewers: [],
        review_time: null,
        can_modify_scope: true
      },
      rules: {
        title: [{ required: true, message: '评审标题不能为空', trigger: 'blur' }],
        review_scope: [{ required: true, message: '评审类型不能为空', trigger: 'blur' }],
        reviewers: [{ required: true, message: '参与人不能为空', trigger: 'blur' }],
        review_time: [{ required: true, message: '计划评审时间不能为空', trigger: 'change' }]
      }
    };
  },
  computed: {
    defaultValue() {
      return moment().add(15, 'minutes');
    },
    getTitle() {
      if (this.isMrd) {
        return '新建业务需求评审';
      }
      if (this.reviewId !== null) {
        return '编辑评审单';
      } else {
        return '添加评审单';
      }
    }
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        if (this.reviewId !== null) {
          this.getReviewDetail(this.reviewId);
        }
      }
    }
  },
  methods: {
    disabledDate(current) {
      return current && current < moment().subtract(1, 'days').endOf('day');
    },
    initMrdInfo(title, list, businessRequirementId) {
      this.form.review_scope = 4;
      this.form.title = title;
      this.form.reviewers = list || [];
      this.form.business_requirement_id = businessRequirementId;
      this.projectId = 1;
    },
    closed() {
      this.visible = false;
      this.loading = false;
      this.form = {
        title: null,
        description: '',
        review_scope: null,
        reviewers: [],
        review_time: null,
        can_modify_scope: true
      };
      this.$emit('close');
    },

    getReviewDetail(reviewId) {
      this.spinning = true;
      reviewDetail({ review_id: reviewId, project_id: this.projectId }).then(res => {
        const data = res.data;
        this.form = {
          ...this.form,
          title: data.title,
          description: data.description,
          status: data.status,
          review_time: data.review_time,
          review_scope: data.review_scope,
          reviewers: data.reviewers ? data.reviewers.map(reviewer => reviewer.id) : [],
          can_modify_scope: data.can_modify_scope
        };
        this.spinning = false;
      });
    },

    // 点击提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.reviewId === null) {
            // 添加评审单
            reviewAdd({ project_id: this.projectId, ...this.form })
              .then(() => {
                this.$emit('addOk');
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            // 编辑评审单
            reviewUpdate({ review_id: this.reviewId, project_id: this.projectId, ...this.form })
              .then(() => {
                this.closed();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 4px;
}

/deep/ .ant-form-item-label {
  line-height: 32px;
}

.submit {
  width: 100px;
  margin: 0 auto;
}

/deep/ .ant-modal-body {
  padding: 8px 48px 16px 48px;
}
</style>
